import { gql } from '@apollo/client';

export default gql`
  mutation ($newCorpMail: String!, $agentId: Int!) {
    changeCorpMail(newCorpMail: $newCorpMail, agentId: $agentId)
  }
`;
